import { render, staticRenderFns } from "./ChangeSerialCounter.vue?vue&type=template&id=2ec76231&scoped=true&"
import script from "./ChangeSerialCounter.vue?vue&type=script&lang=ts&"
export * from "./ChangeSerialCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec76231",
  null
  
)

export default component.exports